import { render, staticRenderFns } from "./ClientDashboards.vue?vue&type=template&id=585b56e0&scoped=true&"
import script from "./ClientDashboards.vue?vue&type=script&lang=js&"
export * from "./ClientDashboards.vue?vue&type=script&lang=js&"
import style0 from "./ClientDashboards.vue?vue&type=style&index=0&id=585b56e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585b56e0",
  null
  
)

export default component.exports